<template>
  <div>
    <!-- <Navbar />
    <Sidebar /> -->
    <section
      class="main"
    >
      <div style="width: 100%;">

        <!-- <h3
          v-if="getLoggedInUser.role === 'TeamLeader'"
          style="font-size: 35px; color:#262E6C ; font-weight: bold;"
        >{{ $t('TeamName') }}: {{ getTeamsNames[0].teamName }}</h3>
        <h3
          v-else
          style="font-size: 35px; color:#262E6C ; font-weight: bold;"
        >{{ $t('ProductionManagement') }}</h3> -->
        <ul style="padding: 0; ">
          <li
            v-for="item in getTeamsNames"
            :key="item.teamNameId"
            class="pm-li"
          >
            <div
              v-if="getLoggedInUser.role != 'TeamLeader'"
              style="display: flex; justify-content: space-between;"
              @click.stop="getTeam(item.teamNameId)"
            >
              <div
                class="activeOrders"
                style="display: flex; align-items: center;"
              >
                <h5
                  style="color:#393939; font-weight: 600; font-size: 20px;"
                >{{ $t('TeamName') }}: {{ item.teamName }}</h5>
                <b> {{ $t('ActiveOrders') }}: {{ item.countItems == null ? 0 : item.countItems }}</b>
              </div>
              <button
                class="btn btn-outline-primary"
                :class="{
                  'hovered': showHide && activeId == item.teamNameId,
                  'notHovered': !(showHide && activeId == item.teamNameId)
                }"
                type="button"
                @click.stop="getTeam(item.teamNameId)"
              >
                {{ showHide == true && activeId == item.teamNameId ? $t('Hide') : $t('Show') }}
                <span v-if="showHide == true && activeId == item.teamNameId "><img
                  style="width:15px"
                  src="../../assets/images/SyMshel.svg"
                ></span>
                <span v-if="!(showHide == true && activeId == item.teamNameId) "><img
                  style="width:15px"
                  src="../../assets/images/SyQel.svg"
                ></span>
              </button>
            </div>
            <ul
              class="ul-order"
              style="z-index: -1"
            >
              <div
                v-if="getTeamOrders.length != 0"
                v-show="showHide == true && item.teamNameId == activeId"
                class="order-header"
              >
                <p style="width: 15%; margin-bottom: 0px;">
                  {{ $t('OrderNumber') }}
                </p>
                <p style="width: 20%; margin-bottom: 0px;">
                  {{ $t('FirstName') }}
                </p>
                <p style="width: 20%; margin-bottom: 0px;">
                  {{ $t('Email') }}
                </p>
                <p style="width: 10%; margin-bottom: 0px;">
                  {{ $t('Gender') }}
                </p>
                <p style="width: 20%; margin-bottom: 0px;">
                  {{ $t('PhoneNumber') }}
                </p>
                <p style="width: 20%; margin-bottom: 0px;">
                  {{ $t('OrderState') }}
                </p>
                <button
                  class="btn btn-outline-primary"
                  type="button"
                  style="visibility: hidden; margin-bottom: 0px; height: 10px;"
                >
                  {{ showO == true ? $t('Hide') : $t('Show') }} {{ $t('Items') }}
                </button>
              </div>
              <li
                v-for="itemd in getTeamOrders"
                v-show="showHide == true && item.teamNameId == activeId"
                :key="itemd.id"
              >
                <div class="order-list">
                  <div
                    class="order-card"
                    style="display: flex; align-items: center; cursor: pointer;"
                    @click.stop="orderItem(itemd.orderNumber, item.teamNameId); editEmployee = false"
                  >
                    <p style="width: 15%">
                      {{ itemd.orderNumber }}
                    </p>
                    <p style="width: 20%">
                      {{ itemd.ordererDto.firstName }} {{ itemd.ordererDto.lastname }}
                    </p>
                    <p style="width: 20%">
                      {{ itemd.ordererDto.email }}
                    </p>
                    <p style="width: 10%">
                      {{ $t(itemd.ordererDto.gender) }}
                    </p>
                    <p style="width: 20%">
                      +{{ countryCallingCode[itemd.ordererDto.countryCode] }} {{ itemd.ordererDto.telephoneNumber }}
                      <!-- {{ itemd.ordererDto.telephoneNumber }} -->
                    </p>
                    <p
                      style="width: 20%; font-weight: bold;"
                      :style="itemd.orderState === 'QualityCheckNotPassed' ? 'color: #e51515' : itemd.orderState === 'InHandSewingQualityNotPassed' ? 'color: #e51515' : itemd.orderState === 'InSewingQualityNotPassed' ? 'color: #e51515' : itemd.orderState === 'InControlCheck' ? 'color: #128EEE' : itemd.orderState === 'InHandSewingQualityPassed' ? 'color: #15E582' : itemd.orderState === 'InSewingQualityPassed' ? 'color: #15E582' : itemd.orderState === 'InPatternCompleted' ? 'color: #15E582' : itemd.orderState === 'InPatternQualityNotPassed' ? 'color: #e51515' :itemd.orderState === 'InPatternQualityPassed' ? 'color: #15E582' : itemd.orderState === 'InPattern' ? 'color: #15E582' : itemd.orderState === 'QualityPassed' ? 'color: #15E582' : itemd.orderState === 'ReadyToDeliver' ? 'color: #15E582' : itemd.orderState === 'Delivered' ? 'color: #15E582' : itemd.orderState === 'InHandSewing' ? 'color: #15E582' : itemd.orderState === 'InSewing' ? 'color: #15E582' : itemd.orderState === 'InProduction' ? 'color: #15E582' : itemd.orderState === 'Confirmed' ? 'color: #128EEE' : itemd.orderState === 'Assigned' ? 'color: #128EEE' : 'color: #e51515'"
                    >
                      {{ $t(itemd.orderState) }}
                    </p>
                    <button
                      class="btn btn-outline-primary"
                      style="width: 10%; margin-bottom: 15px;"
                      :class="{
                        'hovered': showO == true && activeOrderStatus == itemd.orderNumber,
                        'notHovered': !(showO == true && activeOrderStatus == itemd.orderNumber)
                      }"
                      type="button"
                      @click.stop="orderItem(itemd.orderNumber, item.teamNameId); editEmployee = false"
                    >
                      {{ showO == true && activeOrderStatus == itemd.orderNumber ? $t('Hide') : $t('Show') }}
                      <span v-if="showO == true && activeOrderStatus == itemd.orderNumber"><img
                        style="width:15px"
                        src="../../assets/images/SyMshel.svg"
                      ></span>
                      <span v-if="!(showO == true && activeOrderStatus == itemd.orderNumber)"><img
                        style="width:15px"
                        src="../../assets/images/SyQel.svg"
                      ></span>
                    </button>
                  </div>
                  <!-- Repeat the order-card div for each item in the list -->
                </div>
                <ul v-if="showO && activeOrderStatus == itemd.orderNumber">
                  <li
                    v-for="itemz in getArticlesMaterials"
                    v-show="itemd.orderNumber === activeOrderStatus"
                    :key="itemz.id"
                    style="border-top: 1px solid lightgray; padding-top: 2%;"
                  >
                    <div style="display: flex; justify-content: space-between; align-items: center;">
                      <span style="margin-right: 40px">
                        {{ $t('ArticleName') }}: {{ itemz.articleNumber }}</span>
                      <div style="display: flex; justify-content: flex-end; align-items: flex-end;">
                        <button
                          v-b-modal.view-orderItem-details
                          class="btn btn-outline-primary"
                          style="height: 40px;"
                          type="button"
                          @click="loadAllDetails(itemz.orderItemId),
                                  loadDescription(itemd.orderNumber),
                                  loadS(itemz.orderItemId),
                                  showMaterials(itemd.orderNumber, itemz.orderItemId),
                                  loadOrders(itemz.orderItemId),
                                  loadOrderImages(itemd.orderId)
                          "
                        >
                          {{ $t('Show') }} {{ $t('Details') }}
                        </button>
                        <button
                          v-b-modal.processing-users
                          class="btn btn-outline-primary"
                          style="height: 40px; margin-left: 10px;"
                          type="button"
                          @click="callEmployees(itemd.orderState, itemz.orderItemId, itemz.state)"
                        >
                          {{ $t('Show') }} {{ $t('Employees') }}
                        </button>
                        <button
                          v-if="itemz.state == 3"
                          v-b-modal.edit-orderItem-materialVariants
                          style="margin-left: 5px;"
                          class="btn btn-outline-primary"
                          type="button"
                          @click="loadAllDetails(itemz.orderItemId), loadDescription(itemd.orderNumber), loadS(itemz.orderItemId), showMaterials(itemd.orderNumber, itemz.orderItemId),loadOrders(itemz.orderItemId)"
                        >
                          {{ $t('Edit') }} {{ $t('MaterialVariants') }}
                        </button>
                        <img
                          v-b-tooltip="$t('ClickToViewPhoto')"
                          style="height: 43px; border-radius: 6px; cursor: pointer;"
                          src="../../assets/images/imageicon.svg"
                          alt=""
                          @click.stop="getAllImages(itemz.articleNumber)"
                        >
                        <!-- <button
                          v-if="itemz.processingUser == null"
                          v-b-modal.modal-assign-employee
                          style="margin-left: 5px;"
                          class="btn btn-outline-primary"
                          type="button"
                          @click="loadEmployees(itemz.orderItemId)"
                        >
                          {{ $t('AssignEmployee') }}
                        </button> -->
                        <div
                          v-if="itemz.processingUser != null"
                        >
                          <span style="margin-left: 20px;">
                            {{ $t('CurrentEmployee') }}:</span>
                          <div style="display: flex; align-items: center;">
                            <b-input
                              v-if="editEmployee == false"
                              v-model="itemz.processingUser"
                              type="text"
                              disabled
                              style="margin-left: 10px;"
                            />
                            <vue-select
                              v-if="editEmployee == true"
                              v-model="employeeId"
                              :options="getTeamOverview.users"
                              :placeholder="$t('SelectEmployee')"
                              :reduce="(e) => e.userId"
                              label="name"
                              aria-describedby="input-1-live-feedback"
                              style="margin-left: 10px; min-width: 220px;"
                            />
                            <div
                              class="inside-actions"
                              @click="editEmployee = !editEmployee"
                            >
                              <b-icon-pencil v-if="editEmployee == false" />
                              <b-icon-check2
                                v-if="editEmployee == true"
                                @click="editProcessingUser(itemz.orderItemId)"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <br>
                    <div>
                      <div style="margin-right: 10px; margin-top: 20px">
                        <div
                          v-if="stateType === 'High' "
                          style="display: flex; flex-wrap: wrap"
                        >
                          <div
                            v-for="(stage, idx) in stages"
                            :key="idx"
                            v-b-tooltip.hover.bottom
                            :title="stage.name"
                            :class="{
                              failed: itemz.stateDtos[5].stateProcessed == true || itemz.stateDtos[6].stateProcessed == true || itemz.stateDtos[7].stateProcessed == true,
                              active: itemz.stateDtos[idx].stateProcessed == true && (itemz.stateDtos[5].stateProcessed == false || itemz.stateDtos[6].stateProcessed == false || itemz.stateDtos[7].stateProcessed == false),
                              activee: itemz.stateDtos[idx].stateProcessed == true && idx != itemz.state && (itemz.stateDtos[5].stateProcessed == false || itemz.stateDtos[6].stateProcessed == false || itemz.stateDtos[7].stateProcessed == false),
                              disabled: itemz.stateDtos[5].stateProcessed == true || itemz.stateDtos[6].stateProcessed == true || itemz.stateDtos[7].stateProcessed == true
                            }"
                            class="stage-card"
                            @click="changeS(stage.value, itemd.orderNumber, itemz.stateDtos[itemz.state].stateName, itemz.orderItemId, itemz.articleNumber, itemz.qualityCheckerCounter)"
                          >
                            <img
                              class="iconat"
                              alt=""
                              :src="require(`../../assets/images/Materials/Logo-${getLoggedInUser.role == 'TeamLeader'? idx+=1 : getLoggedInUser.role == 'Deliverer'? idx+=7 : idx+1}.svg`)"
                            >
                            <div class="first-div">
                              <div v-if="nState == 'InPatternQualityNotPassed' ">
                                {{ stage.name == 'InPatternQualityNotPassed' ? `Failed Attempts : ${itemz.qualityCheckerCounter}` : '' }}
                              </div>
                              <div v-else-if="nState == 'InSewingQualityNotPassed' ">
                                {{ stage.name == 'InSewingQualityNotPassed' ? `Failed Attempts : ${itemz.qualityCheckerCounter}` : '' }}
                              </div>
                              <div v-else-if="nState == 'InHandSewingQualityNotPassed' ">
                                {{ stage.name == 'InHandSewingQualityNotPassed' ? `Failed Attempts : ${itemz.qualityCheckerCounter}` : '' }}
                              </div>
                              <div v-else-if="nState == 'QualityCheckNotPassed'">
                                {{ stage.value == 'QualityCheckNotPassed' ? `Failed Attempts : ${itemz.qualityCheckerCounter}` : '' }}
                              </div>
                            </div>
                            <div class="second-div">
                              <div v-if="nState == 'InPatternQualityNotPassed' ">
                                <p>{{ stage.value == 'InPatternQualityNotPassed' ? `${shortWords(stage.name)}: ${itemz.qualityCheckerCounter}` : shortWords(stage.name) }}</p>
                              </div>
                              <div v-else-if="nState == 'InSewingQualityNotPassed' ">
                                <p> {{ stage.value == 'InSewingQualityNotPassed' ? `${shortWords(stage.name)}: ${itemz.qualityCheckerCounter}` : shortWords(stage.name) }}</p>
                              </div>
                              <div v-else-if="nState == 'InHandSewingQualityNotPassed' ">
                                <p>{{ stage.value == 'InHandSewingQualityNotPassed' ? `${shortWords(stage.name)}: ${itemz.qualityCheckerCounter}` : shortWords(stage.name) }}</p>
                              </div>
                              <div v-else-if="nState == 'QualityCheckNotPassed'">
                                <p>{{ stage.value == 'QualityCheckNotPassed' ? `${shortWords(stage.name)}: ${itemz.qualityCheckerCounter}` : shortWords(stage.name) }}</p>
                              </div>
                              <div v-else>
                                <p>{{ stage.value == true ? `${shortWords(stage.name)}: ${itemz.qualityCheckerCounter}` : shortWords(stage.name) }}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </section>
    <div style="padding: 0px 30px 10px 118px">
      <b-pagination
        v-if="getTotalItemsForTeams > 15"
        v-model="page"
        style="border:none !important;padding:none !important"
        :total-rows="getTotalItemsForTeams"
        :per-page="pageSize"
        first-number
        last-number
        align="fill"
        prev-class="prev-itemi"
        next-class="next-itemi"
        class="mt-1 mb-0"
      >
        <template #prev-text>
          <span class="previousOrNext"><b-icon-arrow-left />{{ $t('Previous') }}</span>
        </template>
        <template #next-text>
          <span class="previousOrNext">{{ $t('Next') }}<b-icon-arrow-right /></span>
        </template>
      </b-pagination>
    </div>
    <ChangeStatusMaterials
      :coming-status="comingStatus"
      @changeMaterialStatus="changeStage"
    />
    <ViewAllDetailsOrderItem :order-item-id="orderItemId" />
    <EditOrderitemMaterialVariantInProductManagementVue :order-item-id="orderItemId" />
    <vue-easy-lightbox
      :esc-disabled="false"
      :visible="image.visible"
      :imgs="image.imgs"
      @hide="handleHide"
    />
    <AssignEmployeeModal
      :item-id="itemId"
      @assignEmployee="assignProcessingEmployee"
    />
    <ProcessingUserEmployees
      :state-employee="stateEmployee"
      :current-state-of-article="currentStateOfArticle"
      :order-item-id-employee="orderItemIdEmployee"
      @addedEmployees="addEmployees"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import VueEasyLightbox from 'vue-easy-lightbox'
// @ is an alias to /src
import Sidebar from '@/components/sidebars/Sidebar.vue';
import Navbar from '@/components/Navbar.vue';
import ChangeStatusMaterials from '@/components/products/modals/ChangeStatusMaterials.vue'
import AssignEmployeeModal from '@/components/products/modals/AssignEmployeeModal.vue'
import ProcessingUserEmployees from '@/components/ProcessingUserEmployees.vue'
import ViewAllDetailsOrderItem from '../../modals/ViewAllDetailsOrderItem.vue'
import { client } from '../../domainConfig'
import { countryCallingCodes } from '../../countryCodes'
import EditOrderitemMaterialVariantInProductManagementVue from '../../modals/EditOrderitemMaterialVariantInProductManagement.vue'

export default {
  name: 'Materialsmanagement',
  components: {
    // eslint-disable-next-line vue/no-unused-components
    Sidebar,
    VueEasyLightbox,
    AssignEmployeeModal,
    // eslint-disable-next-line vue/no-unused-components
    Navbar,
    ViewAllDetailsOrderItem,
    EditOrderitemMaterialVariantInProductManagementVue,
    ProcessingUserEmployees,
    ChangeStatusMaterials,
  },
  data() {
    return {
      completedSteps: null,
      qualitycheck: null,
      currentStateOfArticle: null,
      stateEmployee: null,
      orderItemIdEmployee: null,
      editEmployee: false,
      itemId: '',
      employeeId: null,
      articleNumber: '',
      image: {
        zoom: 1,
        imgs: [], // Img Url , string or Array of string
        visible: false,
        index: 0, //
      },
      countryCallingCode: countryCallingCodes,
      showS: false,
      dasSize: '',
      showDescription: false,
      client: client.clientName,
      stateType: client.stateType,
      showHide: false,
      showM: false,
      showO: false,
      changeModal: false,
      showTeamInModal: false,
      showLocation: false,
      showTeamControlCheck: false,
      rows: [],
      activeId: '',
      orderStatus: '',
      activeOrderStatus: '',
      orders: [],
      page: 1,
      pageSize: 15,
      oldStatus: '',
      das: '',
      nState: '',
      orderItemId: '',
      comingStatus: {
        orderNumber: {
          type: String,
        },
        orderItemId: {
          type: String,
        },
        newState: {
          type: String,
        },
      },
      qualityFailed: {
        orderNumber: {
          type: String,
        },
        orderItemId: {
          type: String,
        },
        description: {
          type: String,
        },
      },
      ordNum: '',
    };
  },
  computed: {
    ...mapGetters(['getProcessingEmployees', 'getDescriptionOfOrder', 'getTeamOverview', 'getimagesOrder', 'getTwentyPrinciples', 'getProbeDates', 'getimagesProductionManagement',
      'getTeamsNames', 'getOrderItemSize', 'getTotalItemsForTeams', 'getTeamOrders', 'getArticlesMaterials', 'getMaterialVariantsOfOrder', 'getLoggedInUser', 'getIsLoading']),
    stages() {
      return [
        {
          name: this.$t('Created'),
          value: 'Created',
        },
        {
          name: this.$t('Assigned'),
          value: 'Assigned',
        },
        {
          name: this.$t('Confirmed'),
          value: 'Confirmed',
        },
        {
          name: this.$t('ReadyToDeliver'),
          value: 'ReadyToDeliver',
        },
        {
          name: this.$t('Delivered'),
          value: 'Delivered',
        },
        {
          name: this.$t('StockNotAvailable'),
          value: 'StockNotAvailable',
        },
        {
          name: this.$t('QualityCheckNotPassed'),
          value: 'QualityCheckNotPassed',
        },
        {
          name: this.$t('Cancelled'),
          value: 'Cancelled',
        },
      ]
    },
  },
  watch: {
    // eslint-disable-next-line func-names
    page(value) {
      this.teamNames({
        pageNumber: value,
        pageSize: this.pageSize,
      })
      // this.$router.replace({ name: 'Product Management', query: { page: this.page, pageSize: this.pageSize } }).catch(() => {})
    },
    editEmployee(value) {
      if (value == true) {
        this.teamByTeamNameId(this.activeId)
      }
    },
    filters: {
      // eslint-disable-next-line func-names
      handler() {
        // this.$router.replace({ name: 'Product Management', query: { page: this.page, pageSize: this.pageSize } }).catch(() => {})
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.fetch()
  },
  methods: {
    ...mapActions([
      'assignEmployeeToOrderItem',
      'teamByTeamNameId',
      'orderItemStates',
      'getFileByOrderNumber',
      'loadTwentyPrinciplesOrSize',
      'getOrderItemsManagementByMaterials',
      'getOrderById',
      'updateOrderStatus',
      'materialVariantsByOrderNAndArticleN',
      'resetMaterialVariantsOfOrders',
      'updateToQualityNotPassed',
      'changeLoadingtoTrue',
      'resergetOrderById',
      'loadProbeDates',
      'loadPrices',
      'getFileByArticleNumber',
      'loadDescriptionOfOrder',
      'resetTwentyPrinciplesOrSize',
      'resetDescriptionOfOrder',
      'teamNames',
      'locations_by_type',
      'resetGetOrderItemsManagementByMaterials',
      'dropdown_TeamNames',
      'loadOrderItemLocation',
      'resetLoadOrderItemLocation',
      'trackProcessingEmployees',
      'addProcessingEmployees',
      'assignProcessinEmployee',
      'updateOrderStatusForce',
      'updateMaterialStatus',
    ]),
    async fetch() {
      try {
        // this.changeLoadingtoTrue(false)


        await this.teamNames({
          pageNumber: this.page,
          pageSize: this.pageSize,
        })
          .then((res) => {
            console.log(res);
            // this.changeLoadingtoTrue(true);
          });

        if (this.getLoggedInUser.role === 'TeamLeader') {
          await this.getTeam(this.getTeamsNames[0].teamNameId);
        }
      } catch (e) {
        console.log(e);
        // this.changeLoadingtoTrue(false)
      }
    },
    addEmployees(obj) {
      console.log('oj', obj)
      this.assignProcessinEmployee({
        object: obj,
        successCallback: () => {
          this.trackProcessingEmployees({
            orderItemId: this.orderItemIdEmployee,
            currentState: this.stateEmployee,
          })
        },
      })
    },
    callEmployees(itemd, itemz, itemzz) {
      this.orderItemIdEmployee = itemz
      this.stateEmployee = itemd
      this.currentStateOfArticle = itemzz
      this.trackProcessingEmployees({
        orderItemId: itemz,
        currentState: itemd,
      })
      this.teamByTeamNameId(this.activeId)
    },
    shortWords(name) {
      if (name.length > 25) {
        return `${name.slice(0, 25)}...`;
      }
      return name;
    },
    loadAllDetails(orderItem) {
      // this.$router.push(`/${orderItem}`, { props: { myProps: orderItem } })
      // this.$router.replace({ name: 'Product Management', query: { page: this.page, pageSize: this.pageSize, orderItem } }).catch(() => {})
      // this.$router.push({
      //   name: 'production-management',
      //   params: { id: orderItem },
      // })
      this.orderItemId = orderItem;
      this.loadProbeDates(orderItem);
      this.loadPrices(orderItem)
    },
    async loadOrderImages(value) {
      this.$store.commit('SET_IMAGES_ORDER', [{
        fileDataId: 'aaf153a4-be48-ee11-abf3-124abb807f69',
        mainDressColorId: 'e2b146ea-a7e9-4584-ee19-08dba4a55447',
        url: '',
        fileName: '1693569414176-createordermodal.png',
      }]);
      await this.getFileByOrderNumber(value);
      this.image.imgs = []
      for (let i = 0; i < this.getimagesOrder.length; i++) {
        const image = this.getimagesOrder[i]
        this.image.imgs.push({
          src: image.url,
          title: image.fileName,
          fileDataId: image.fileDataId,
          fileName: image.fileName,
          fileType: image.fileType,
        })
      }
    },
    async getAllImages(value) {
      this.$store.commit('SET_IMAGES_PRODUCTION_MANAGEMENT', [{
        fileDataId: 'aaf153a4-be48-ee11-abf3-124abb807f69',
        mainDressColorId: 'e2b146ea-a7e9-4584-ee19-08dba4a55447',
        url: '',
        fileName: '1693569414176-createordermodal.png',
      }]);
      await this.getFileByArticleNumber(value);
      this.image.imgs = []
      for (let i = 0; i < this.getimagesProductionManagement.length; i++) {
        const image = this.getimagesProductionManagement[i]
        this.image.imgs.push({
          src: image.url,
          title: image.fileName,
          fileDataId: image.fileDataId,
          fileName: image.fileName,
          fileType: image.fileType,
        })
      }
      this.show()
    },
    show() {
      this.image.visible = true
    },
    handleHide() {
      this.image.visible = false
    },
    loadEmployees(value) {
      this.teamByTeamNameId(this.activeId)
      this.itemId = value
    },
    editProcessingUser(value) {
      const object = {
        orderItemId: value, // Added a colon after 'orderItemId'
        message: '',
        processingUserId: this.employeeId,
      };

      this.assignEmployeeToOrderItem({
        object,
        successCallback: () => {
          this.getOrderItemsManagementByMaterials({
            orderNr: this.activeOrderStatus,
            id: this.activeId,
          });
        },
      });
    },
    assignProcessingEmployee(object) {
      this.assignEmployeeToOrderItem({
        object,
        successCallback: () => {
          this.getOrderItemsManagementByMaterials({
            orderNr: this.activeOrderStatus,
            id: this.activeId,
          });
        },
      });
    },
    async orderItem(orderN, activeId, item) {
      // this.changeLoadingtoTrue(false)
      console.log(orderN)
      console.log(activeId)
      console.log(item)


      if (this.activeOrderStatus === orderN && this.showO) { // Condition to skip request
        this.activeOrderStatus = ''
        this.showO = false
      } else {
        this.activeOrderStatus = orderN
        this.showO = true
        this.resetGetOrderItemsManagementByMaterials()
        await this.getOrderItemsManagementByMaterials({
          orderNr: orderN,
          id: activeId,
        })
      }

      this.resetMaterialVariantsOfOrders()
      this.showM = false
      // this.changeLoadingtoTrue(true)
    },
    async loadS(orderItemUnik) {
      // this.changeLoadingtoTrue(false)

      this.resetTwentyPrinciplesOrSize()
      await this.loadTwentyPrinciplesOrSize(orderItemUnik);
      this.showS = !this.showS;

      if (this.dasSize === orderItemUnik) {
        this.dasSize = '';
        this.showS = false;
      } else {
        this.dasSize = orderItemUnik;
        this.showS = true;
      }
      // this.changeLoadingtoTrue(true)
    },
    async loadDescription(value) {
      // this.changeLoadingtoTrue(false)

      this.resetDescriptionOfOrder()
      await this.loadDescriptionOfOrder(value);
      // this.changeLoadingtoTrue(true)
    },
    changeS(item, oNumber, oStatus, orderItem, articleNumber) {
      if (
        (oStatus === 'Created' && item === 'Assigned')
    || (oStatus === 'Assigned' && (item === 'Confirmed' || item === 'QualityCheckNotPassed' || item === 'Cancelled'))
    || (oStatus === 'Confirmed' && (item === 'ReadyToDeliver' || item === 'QualityCheckNotPassed' || item === 'Cancelled'))
    || (oStatus === 'ReadyToDeliver' && (item === 'Delivered' || item === 'QualityCheckNotPassed' || item === 'Cancelled'))
      ) {
        this.$bvModal.show('modal-change-material');
        this.articleNumber = articleNumber
        this.comingStatus.newState = item;
        this.comingStatus.orderNumber = oNumber;
        this.oldStatus = oStatus;
        this.comingStatus.orderItemId = orderItem;
        this.completedSteps = false
        this.changeModal = false;
        this.showTeamInModal = false;
        this.showLocation = false;
        this.showTeamControlCheck = false
        this.teamByTeamNameId(this.activeId)
        this.locations_by_type('WarehouseForClient');
      }
    },
    async changeStage(item) {
      await this.updateMaterialStatus({
        object: item,
        successCallback: () => {
          this.getOrderItemsManagementByMaterials({
            orderNr: item.orderNumber,
            id: this.activeId,
          });
          this.getOrderById(
            {
              id: this.activeId,
              salesType: 'Material',
            },
          )
          this.comingStatus = {
            newState: {},
            orderNumber: {},
            orderItemId: {},
            locationId: null,
            notes: null,
          }
        },
      });
    },
    async showMaterials(orderN, orderItemUnik) {
      // this.changeLoadingtoTrue(false)

      await this.materialVariantsByOrderNAndArticleN({
        orderNumber: orderN,
        orderItemId: orderItemUnik,
      });
      this.showM = !this.showM;
      if (this.das === orderItemUnik) {
        this.das = '';
        this.showM = false;
      } else {
        this.das = orderItemUnik;
        this.showM = true;
      }
      // this.changeLoadingtoTrue(true)
    },
    async loadOrders(value) {
      this.resetLoadOrderItemLocation()
      await this.loadOrderItemLocation({
        orderItemId: value,
        articleNumber: null,
        clientId: null,
      })
    },
    async getTeam(id) {
      // this.changeLoadingtoTrue(false)

      this.resergetOrderById()
      if (this.activeId === id && this.showHide) { // Condition to skip request
        this.activeId = ''
        this.showHide = false
      } else {
        this.activeId = id
        this.showHide = true
        await this.getOrderById(
          {
            id,
            salesType: 'Material',
          },
        )
      }

      // this.changeLoadingtoTrue(true)
    },
  },
};
</script>

<style scoped lang="scss">
.notHovered{
  background: #FF274F !important;
    color: #f4f1ed;
    border-color: transparent;
    width:10%
}
.hovered{
  background: white !important;
    color: #FF274F;
    border:1px solid #FF274F ;
    width:10%

}
.iconat{
  width:80px;
  height: 80px;
}
.second-div{
  display: none;
}
.inside-actions {
  margin-left: 8px;
  cursor: pointer;
  border: 1px solid transparent;
  padding: 0px 4px;
  border-radius: 7px;
}

.inside-actions:hover {
  background-color: #242F6E;
  color: #fff;
}
.activeOrders{
  display: flex;
  justify-content: space-between;
  width: 88%;
}

.activeOrders b{
  color:#15E582;
}
.hr{
  background-color: grey;
  min-width: 201px;
  height: 1px;
  border: 0.5px solid #A5A5A5;
  opacity: 0.34;
}
.material-info:last-child {
  margin-right: 0 !important;
}
.pm-li {
  cursor:pointer;
  list-style: none;
  background: #ffffff;
  overflow-y: auto;
  border-radius: 8px;
  border: 1px solid #DADBDC;
  padding: 12px 10px;
  margin-bottom: 20px;
}
.pm-li h5 {
  margin-bottom: 0;
}
.ul-order {
  padding: 0;
  display: grid;
  grid-template-columns: 1fr;
  gap: 15px;
  cursor:default;
  background: #F6F6F6;
  border-radius: 8px;
}
.ul-order li {
  background: #F6F6F6;
  overflow-y: auto;
  border-bottom: 1px solid #DADBDC;
  padding: 0px 10px 6px 10px;
  margin-top: 15px;
  color:black ; font-weight: 400;font-size: 15px;
}
.ul-order ul {
  padding-left: 5px;
}

.order-card {
  cursor:default;
  display: flex;
}

.order-card p {
  margin-right: 20px;
  color:black ; font-weight: 500;font-size: 15px;
  word-break: break-word;
  border-right: 1px solid #393939;
}
.stage-card {
  background: #ffffff;
  border-radius: 4px;
  padding: 10px;
  margin-bottom: 15px;
  margin-right: 10px;
  cursor: pointer;
  opacity: 0.3;
}
.stage-card:hover {
 background: #ffe8fc;
}
.stage-card.active {
  background: none !important;
  color: #f4f1ed;
  border-color: transparent;
  opacity: 1 !important;
}
.stage-card.activee {
  background-color: grey;
  opacity: 1;
  border-image-slice: 1;
  border-width: 5px;
}
.stage-card.disabled {
  opacity: 0.4;
  pointer-events: none;
  cursor: not-allowed;
}
.black-bg {
  background:white;
  opacity: 0.9;
  color: black;
  border-top:2px solid;
  border-image-slice: 1;
  border-width: 5px;
  border-image-source: linear-gradient(to left, #e51515  70% , #424242 );
}
.black-bg:hover {
  background:white;
  opacity: 0.9;
  color: black;
  border-top:2px solid;
  border-image-slice: 1;
  border-width: 5px;
  border-image-source: linear-gradient(to left, #e51515  70% , #424242 );
}
.faileedd:hover{
  background: #FF274F !important;
  opacity: 0.7;
  color: #ffffff;
  border-top:2px solid;
  border-image-slice: 1;
  border-width: 5px;
  border-image-source: linear-gradient(to left, #e51515  70% , #424242 );
}
.faileedd {
  background: #FF274F !important;
  opacity: 0.7;
  color: #ffffff;
  border-top:2px solid;
  border-image-slice: 1;
  border-width: 5px;
  border-image-source: linear-gradient(to left, #e51515  70% , #424242 );
}
.stage-card.failed {
  background: #FF274F !important;
  opacity: 0.7;
  color: #ffffff;
  border-top:2px solid;
  border-image-slice: 1;
  border-width: 5px;
  border-image-source: linear-gradient(to left, #e51515  70% , #424242 );
}
.order-header{
  display: flex;
  font: normal normal bold 15px/19px;
  font-weight: bold;
  font-size: 15px;
  padding: 10px;
}
.order-header{
  color:#393939 ; font-weight: 400; font-size: 14px;
}

@media screen and (min-width: 1200px) and (max-width: 1500px) {
  .main {
    padding: 75px 15px 15px 90px !important;
  }
}

 @media screen and (max-width: 1200px){
  .iconat{
  width:35px;
  height: 35px;
}
  .first-div{
    display: none;

  }
  .second-div{
    display: block;
  }
  .second-div p {
    font-size: 12px;
    color:black;
  }
  .activeOrders b{
    color:#15E582;
    margin-right: 20px;
  }
  .stage-card{
    width: 205px;
  }
 }
 @media screen and (max-width: 1190px) {

.main {
  padding: 116px 0.75rem 0 0.75rem !important;
  /* justify-content: center; */
}
}
</style>
